/**
 * Mandatory upload exception rules.
 *
 * These patterns are ALWAYS applied when uploading projects, in addition to
 * any .gitignore rules found in the uploaded repository.
 *
 * Flow:
 * 1. First, read .gitignore from the uploaded repo (if exists)
 * 2. Then, apply these mandatory exception rules on top
 *
 * To add new patterns, simply add them to the appropriate category array below.
 * Patterns use .gitignore syntax (https://git-scm.com/docs/gitignore).
 */

/**
 * Hidden files and folders (starting with .)
 * Always exclude hidden folders like .git, .config, .env, etc.
 */
const HIDDEN_FILES_AND_FOLDERS = [
  '.*' // All hidden files and folders
]

/**
 * Build output directories at top level
 * These contain generated artifacts that shouldn't be uploaded
 */
const TOP_LEVEL_BUILD_DIRECTORIES = [
  '/target/', // Maven/Gradle build output (top-level only)
  '/dist/', // Distribution/build output (top-level only)
  '/coverage/' // Test coverage reports (top-level only)
]

/**
 * Log files
 */
const LOG_FILES = ['*.log']

/**
 * Binary artifacts that should never be uploaded
 */
const BINARY_ARTIFACTS = [
  '*.jar', // Java archives
  '*.war', // Web application archives
  '*.exe' // Windows executables
]

// =============================================================================
// Combine all mandatory exception rules
// =============================================================================

/**
 * All mandatory exception patterns that are always applied
 */
export const MANDATORY_UPLOAD_EXCEPTIONS = [
  ...HIDDEN_FILES_AND_FOLDERS,
  ...TOP_LEVEL_BUILD_DIRECTORIES,
  ...LOG_FILES,
  ...BINARY_ARTIFACTS
]

/**
 * Get the mandatory exception rules as a newline-separated string
 * Compatible with the 'ignore' library
 */
export function getMandatoryExceptionsString(): string {
  return MANDATORY_UPLOAD_EXCEPTIONS.join('\n')
}

/**
 * Export individual category arrays for fine-grained control if needed
 */
export const UploadExceptionCategories = {
  HIDDEN_FILES_AND_FOLDERS,
  TOP_LEVEL_BUILD_DIRECTORIES,
  LOG_FILES,
  BINARY_ARTIFACTS
}
